// mutations/addSignatureMutation.js
import { gql } from '@apollo/client';

export const ADD_SIGNATURE = gql`
  mutation AddSignature($name: String!, $content: String!, $employeeId: String!) {
    addSignature(name: $name, content: $content, employeeId: $employeeId) {
    status
    message
    response {
      id
      name
      content
      employeeId
    }
  }
}
`;
export const UPDATE_SIGNATURE = gql`
  mutation UpdateSignature($id: String!, $name: String!, $content: String!) {
    updateSignature(id: $id, name: $name, content: $content) {
      status
      message
      response {
        id
        name
        content
        employeeId
      }
    }
  }
`;

export const DELETE_SIGNATURE = gql`
  mutation DeleteSignature($id: String!) {
    deleteSignature(id: $id) {
      status
      message
      response {
        id
      }
    }
  }
`;

export const GET_ALL_SIGNATURES = gql`
  query getAllSignatures($employeeId: String!) {
    getAllSignatures(employeeId: $employeeId) {
      status
      message
      response {
        id
        name
        content
        employeeId
      }
    }
  }
`;
